/**
 * Parse the jobs "Open to applications" URL/query value.
 * Default is ON when the param is absent (matches logged-in default).
 *
 * @param {string|boolean|number|null|undefined} status
 * @returns {boolean}
 */
export default function parseJobsStatus(status) {
  if (status === undefined || status === null || status === '') {
    return true;
  }
  if (status === false || status === 0) {
    return false;
  }
  const normalized = String(status).toLowerCase();
  if (normalized === 'false' || normalized === '0') {
    return false;
  }
  return true;
}
